import { cva, VariantProps } from "cva";

import Badge from "./Badge";
import * as styles from "./Badge.module.css";

export const variants = cva({
  base: styles.base,
  variants: {
    variant: {
      dot: styles.dot,
      solid: styles.solid,
      lighted: styles.lighted,
    },
    color: {
      primary: styles.primary,
      caution: styles.caution,
      transparent: styles.transparent,
    },
    size: {
      s: styles.s,
      m: styles.m,
      l: styles.l,
      xl: styles.xl,
    },
  },
  defaultVariants: {
    variant: "dot",
    size: "m",
  },
});

export type BadgeProps = VariantProps<typeof variants> &
  React.HtmlHTMLAttributes<HTMLSpanElement> & {
    number?: number;
  };

export { Badge };
